import * as getters from "@/store/session/getters";
import * as mutations from "@/store/session/mutations";
import * as actions from "@/store/session/actions";
import { makeState, SessionState } from "@/store/session/state";
import { Action, Getter, Mutation } from "vuex";
import { RootState } from "@/store/types";

// Type definition for the session module vuex state object.
export interface SessionModule {
  namespaced: boolean;
  state: SessionState;
  getters: Record<string, Getter<SessionState, RootState>>;
  mutations: Record<string, Mutation<SessionState>>;
  actions: Record<string, Action<SessionState, RootState>>;
}

/**
 * Factory function for creating the namespaced session vuex module.
 * @returns session module configured for the inclusion in a vuex state.
 */
export function makeSessionModule(): SessionModule {
  return {
    namespaced: true,
    state: makeState(),
    getters,
    mutations,
    actions,
  };
}
